const indexDocTemplate = `
<div class="row">
  <div class="col-md-12">
    <div ui-view="breadcrumb"></div>
    
    <ui-view>
        <div class="inner-container with-padding marketing-content">
            <div class="center-block">
                <h2>Available Legal Documents</h2>
                <div class="list-group">
                    <a
                        ng-repeat="docLink in vm.docLinks"
                        class="list-group-item"
                        ui-sref="docs.page({ page: docLink.name })"
                        >
                        {{ docLink.text }}
                    </a>
                </div>
            </div>
        </div>
    </ui-view>
  </div>
</div>
`;
export default indexDocTemplate;
